import { LocalStorage } from 'quasar'
import { date } from 'quasar'
const { getDateDiff } = date

/**
 *
 * @param {String} path
 * @param {*} maxAgeInMinutes
 * @returns
 */
export function getFromLocalStorage(path, maxAgeInMinutes = null) {
  const keys = path.split('/')
  const parentKey = keys[0]
  const childKey = keys.length > 1 ? keys[1] : null

  if (LocalStorage.has(parentKey)) {
    const storedData = LocalStorage.getItem(parentKey)
    let item

    if (childKey) {
      item = storedData?.[childKey]
    } else {
      item = storedData
    }

    if (!item) return null

    if (maxAgeInMinutes !== null) {
      const diff = getDateDiff(new Date(), item.savedOn, 'minutes')
      if (diff > maxAgeInMinutes) return null
    }

    return item.hasOwnProperty('value') ? item.value : item
  }
  return null
}

export function removeFromLocalStorage(path) {
  const keys = path.split('/')
  const parentKey = keys[0]
  const childKey = keys.length > 1 ? keys[1] : null


  if (childKey) {
    const storedData = LocalStorage.getItem(parentKey) || {}
    delete storedData[childKey]
    LocalStorage.set(parentKey, storedData)
  } else {
    LocalStorage.remove(parentKey)
  }
}

export function saveToLocalStorage(path, data, timestamp = false) {
  const keys = path.split('/')
  const parentKey = keys[0]
  const childKey = keys.length > 1 ? keys[1] : null

  /* let payload;
  if (typeof data === 'object' && data !== null) {
        payload = { ...data, savedOn: new Date() };
    } else {
        payload = {
            value: data,
            savedOn: new Date()
        };
    } */

  let payload = {}

  if(timestamp){
    payload = {
      value: data,
      savedOn: new Date(),
    }
  } else  {
    payload  = data
  }

  if (childKey) {
    const storedData = LocalStorage.getItem(parentKey) || {}
    storedData[childKey] = payload
    LocalStorage.set(parentKey, storedData)
  } else {
    LocalStorage.set(parentKey, payload)
  }
}